<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-form-item label="车队" prop="code" style="margin-right:15px">
          <el-select v-model="form.code" clearable placeholder="请选择">
            <el-option
              v-for="item in teamList"
              :key="item.acceptCode"
              :label="item.linkMan"
              :value="item.acceptCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="代收协议" prop="collection" style="margin-right:15px">
          <el-checkbox
            v-model="form.collection"
            false-label=""
            :true-label="1"
          >同意</el-checkbox>
          <a style="margin-left: 20px;color: #1890ff;" @click="showCollectionAgreementModel">《收款委托函》</a>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
    <vxe-modal v-model="collectionAgreementFlag" title="代收协议" width="800" height="800" resize>
      <collectionAgreement ref="collectionAgreementRef" action-path="new" @hideModel="hideCollectionAgreementModel" />
    </vxe-modal>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import collectionAgreement from "./collectionAgreement.vue";
  export default {
    name: 'AddCollectionAgreement',
    components: {
      collectionAgreement
    },
    data() {
      return {
        teamList:[],
        collectionAgreementFlag: false,
        form: {
          code: '',
          collection: ''
        },
        rules: {
          code: [
            { required: true, message: '请选择车队', trigger: 'blur' }
          ],
          collection: [
            { required: true, message: '请同意代收协议', trigger: 'blur' }
          ]
        }
      }
    },
    created() {},
    methods: {
      hideCollectionAgreementModel(){
        this.collectionAgreementFlag = false;
      },
      showCollectionAgreementModel(){
        if(this.form.code){
          this.collectionAgreementFlag = true;
          this.$refs.collectionAgreementRef.init(this.form.code);
        }else{
          this.$message({ message: "请先选择车队", type: 'error' });
        }
      },
      init(driverCode) {
        this.loading = true;
        return new Promise(resolve => {
          request({
            url: '/ntocc-basic-api/driver/joinedTeamList',
            method: 'get',
            params: {partyCode: driverCode,pageNum: 1,pageSize: 1000}
          }).then(response => {
            this.teamList = response.data.records;
            this.loading = false;
            resolve();
          })
        })
      },
      //提交
      funcSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const rLoading = this.openLoading();
            request({ url: '/ntocc-tms-api/acceptVehicle/accept/'+this.form.code, method: 'get', params: {} }).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: 'success' })
              this.$emit('hideModel')
            }).then(()=>this.$refs['form'].resetFields())
          } else {
            return false;
          }
        });
      },
      //取消
      funcCancel() {
        this.$emit('hideModel')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin:15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
